// Imports
import { useStateValue } from 'src/modules/_global/jsx/store';

// The individual Progression Nav List Item

export const ReactProgressItem = (props) => {

    const [{ globalText, userData, controlData, questionSectionData }, dispatch] = useStateValue();

    // Click handler for the button, dispatches event passing through the asset id
    const clickHandler = (event) => {
        event.preventDefault();
        let appNameString = globalText.gaAppName;
        let navName = event.currentTarget.getAttribute('data-name');
        let appLabel = `Navigation menu - ${navName}`;
    
        // fix for window.dataLayer undefined in Firefox
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({"event": "interaction", "target": appNameString, "action": "button click", "label": (appLabel)}); 

        dispatch({
            type: 'mainNavClick',
            value: { assetID: props.assetID }
        });
    }

    // Click handler for the assessment item
    const assessmentClickHandler = (event) => {
        event.preventDefault();
        
        // If Assessment is available
        if (userData.availableNavItems.indexOf(props.assetID) !== -1) {
            dispatch({
                type: 'mainNavClick_assessment',
                value: { assetID: props.assetID }
            });
        }
    }

    // Returns the progress of the relevant Detailed Question Section (not-started, in-progress or done)
    const getDAQuestionSectionProgress = () => {
        let progressState = null;
        let sectionData = questionSectionData[props.assetID];
        
        // If this nav item is a Question Section
        if (typeof(sectionData) !== 'undefined') {

            // If this nav item is a Detailed Question Section
            if (sectionData.assessmentType === 'detailed') {
                let sectionQuestions = sectionData.children;

                // If this nav item has children (ie. questions)
                if (typeof(sectionQuestions) !== 'undefined') {
                    progressState = 'not-started';

                    
                    if (sectionData.linkedSection.length) {
                        // If this is the current item then the section is in progress, and user hasnt scored 100% in the linked rapid section
                        if (props.assetID === controlData.currentItem.topLevelAsset && getUserResultsOfRapidQuestionSection(sectionData.linkedSection) !== 100) {
                            progressState = 'in-progress';

                        // Else check how many questions are answered and compare with total
                        } else {

                        


                            //filter out the questions that are linked to rapid assessment questions in which the user has selected Yes(0);
                            var filteredQuestions = sectionQuestions.filter((question) =>{
                                if (question.qType === 'rangeSlider') {
                                    //check if the this question has a linked rapid assessment question
                                    //linkedRapidQuestion
                                    if(typeof(question.linkedRapidQuestion) !== "undefined"){
                                        if(question.linkedRapidQuestion !== ""){
                                            var userResponse = userData.questionResponses[question.linkedRapidQuestion]; 
                                            //if the user has answered yes(0) - then do not show this question
                                            if(userResponse === 0){
                                                return false;
                                            }
                                        }
                                    }
                                    return true;
                                }
                                return false;
                            });     

                            //let noOfQuestions = sectionQuestions.length;
                            let noOfQuestions = filteredQuestions.length;



                            
                            let answeredQuestions = sectionQuestions.filter((question) => {
                                return userData.questionResponses.hasOwnProperty(question.assetID);
                            });
                            let noOfAnsweredQuestions = answeredQuestions.length;
                            
                            //if the rapid assessment linked question section got 100% show as done
                            if(getUserResultsOfRapidQuestionSection(sectionData.linkedSection) === 100){
                                progressState = 'done';
                            }else{

                                // If all questions are answered
                                if (noOfAnsweredQuestions >= noOfQuestions) {
                                    progressState = 'done';
                                
                                } else if (noOfAnsweredQuestions > 0) {
                                    progressState = 'in-progress';
                                }
                            }
                        }
                    } else {
                        if(props.assetID === controlData.currentItem.topLevelAsset) {
                            progressState = 'in-progress';
                        } else {
                            let answeredQuestions = sectionQuestions.filter((question) => {
                                return userData.questionResponses.hasOwnProperty(question.assetID);
                            });

                            if (answeredQuestions.length) {
                                progressState = 'done';
                            }
                        }
                    }
                }
            }
        }

        return progressState;
    }

    // Returns the appropriate classes for the List Item
    const returnClasses = () => {

        var classes = ['br-app-progression-nav__links__list__item'];

        if(props.isAssessment === true){
            classes.push('br-app-progression-nav__links__list__accordion');
            if (userData.expandedItem === props.assetID) {
                classes.push('expanded');
            }
        }

        //if the item has been completed
        if (userData.availableNavItems.indexOf(props.assetID) !== -1) {
            classes.push('complete');
        }

        //if the item is the current item
        if (props.assetID === controlData.currentItem.topLevelAsset) {
            classes.push('current');
        }

        // Check detailed section progress
        let progressState = getDAQuestionSectionProgress();
        if (progressState !== null) {
            classes.push(progressState);
        }

        //create the classes
        var classNames = classes.reduce((total, value) => {
            return total + " " + value;
        });

        return classNames;

    }

    // Returns the List Item
    const returnListItem = () => {        

        let assessmentItem;
        //if this is an assessment and has children        
        if(props.isAssessment === true){
            if(props.children.length > 0){
                
                assessmentItem = <li className={returnClasses()} key="{props.assetID}">
                    <a href="#" className="br-app-progression-nav__links__list__item__link" onClick={assessmentClickHandler}>{props.navName}</a>
                    <ul className="br-app-progression-nav__links__list__accordion_list">
                        {props.children}
                    </ul>
                </li>
                return assessmentItem;
            }
        }

        // Internals of the List item if the page has been visited by the user
        let listItemInternal = <a href="#" className="br-app-progression-nav__links__list__item__link" data-name={props.navName} onClick={clickHandler}>{props.navName}</a>;

        //if the Page has note been visited by the user set the internals to a span instead of a clickable link
        if (userData.availableNavItems.indexOf(props.assetID) === -1) {
            listItemInternal = <span className="br-app-progression-nav__links__list__item__link" >{props.navName}</span>
        }
        
        return (
            <li className={returnClasses()} key="{props.assetID}">
                {listItemInternal}
            </li>
        );
    }





    // Get 
    const getRapidQsectionFromAssetID = (rQsectionAssetID) => {
        //filter out all but the rapid sections
        let rapidQsections = Object.values(questionSectionData).filter(
            (item) => {
                return item.assessmentType == "rapid";
            }
        )
        //find the rapid section by assetId from the passed parameter
        let rapidSection = rapidQsections.find((item) =>{
            return item.assetID == rQsectionAssetID;
        })

        return rapidSection;
    }

    // Get percentage score for the linked Rapid Assessment section
    const getUserResultsOfRapidQuestionSection = (rQsectionAssetID) => {
        let rapidQsection = getRapidQsectionFromAssetID(rQsectionAssetID);
        
        let sectionQuestions = rapidQsection.children;       
        let noOfQuestions = sectionQuestions.length;
        let totalScore = 0;
        sectionQuestions.forEach(question => {
            let rQassetID = question.assetID;
            let score = userData.questionResponses[rQassetID];

            if (score === 0) {
                totalScore++;
            } else if (score === 3) {
                noOfQuestions--;
            }
        });

        let percentage = totalScore / noOfQuestions * 100;
       // console.log("totalScore for section:",rapidQsection.navName ,totalScore);
        //console.log("percentage score for section:",rapidQsection.navName ,percentage);

        return percentage;
    }














    // Component render
    return (
        returnListItem()
    );
};


